import {PersonRetirement} from './retirement/person-retirement';
import {BuildMoneyProject} from './build-money-project';
import {EphesoAnalisys} from './retirement/epheso/epheso-analisys';
import {RisultatiPrevidenza} from './retirement/epheso/risultati-previdenza';
import {AniaRetirementRequest} from './retirement/ania/request/retirement/ania-retirement-request';
import {AniaRetirementResponse} from './retirement/ania/response/retirement/ania-retirement-response';

export class BoardProject extends BuildMoneyProject {
  personRetirement: PersonRetirement;
  createIntegration: boolean;
  incomeGrow: number;
  startingJobDate: any;
  jobCategoryCode: number;
  jobGrowing: number;
  conjugated: boolean;
  childNumber: number;
  aniaResponse: AniaRetirementResponse;
  type = 2;

}
